module.exports = __webpack_public_path__ + "static/media/petitioner_simple.bb4d74f0.pdf";